import IconButton from "components/atoms/button/IconButton";
import Form from "components/atoms/form/Form";
import Icon from "components/atoms/icon/Icon";
import Check2Icon from "components/atoms/icon/icon-type/Check2Icon";
import Check3Icon from "components/atoms/icon/icon-type/Check3Icon";
import Check4Icon from "components/atoms/icon/icon-type/Check4Icon";
import CheckIcon from "components/atoms/icon/icon-type/CheckIcon";
import LoadingScreen from "components/atoms/loading-screen/LoadingScreen";
import FileDropZone from "components/molecules/file-dropzone/FileDropZone";
import { IconType } from "lib/helpers/constants/iconTypes";
import { useUploadLeadManually } from "lib/hooks/mutations/Leads/useUploadLeadManually";
import { FC, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

export interface IStep1Props {
  setStep: (args: number) => void;
  handleFormValuesChange: (step: number, values: any) => void;
  formValues: any;
  themeColors: {
    primary: string;
  };
}

const Step1: FC<IStep1Props> = ({
  setStep,
  handleFormValuesChange,
  formValues,
  themeColors,
}) => {
  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm();

  const { mutateAsync: uploadLeadFileManually, isLoading } =
    useUploadLeadManually();

  const onSubmit = async (data: Record<string, any>): Promise<void> => {
    handleFormValuesChange(1, data);

    const formData = new FormData();

    if (data.file) {
      formData.append("file", data.file[0] as FileList[0]);
    }

    for (const key in formValues) {
      formData.append(key, formValues[key]);
    }

    uploadLeadFileManually(formData as any)
      .then(() => {
        setStep(2);
      })
      .catch(() => { });
  };
  const { t } = useTranslation();
  const [resetCount, setresetCount] = useState<number>(0);

  return (
    <Form onSubmit={handleSubmit(onSubmit)} className="mb-0 flex flex-col pl-4">
      <div className="border-l-[1.5px] border-dashed border-[#D8D8D8] pl-7 pb-9 relative bg-transparent">
        <div className="pl-2 text-[14px] font-inter-medium pb-5">
          {t('Upload CSV')}
        </div>

        <Controller
          control={control}
          name="file"
          rules={{ required: t("File is required") }}
          render={({ field: { onChange, value } }) => (
            <FileDropZone
              key={`file-dropzone-${resetCount}`}
              formats={".csv"}
              file={value}
              setFile={onChange}
              label=""
              classes={{ label: "bg-white" }}
              name="file"
              error={errors.file}
              control={control}
            />
          )}
        />
        <div className="absolute top-[0] left-[-12px] z-9999">
          <CheckIcon color={themeColors.primary} />
        </div>
        {isLoading && <LoadingScreen className="!h-[250px] !top-[40px]" />}
      </div>
      <div className="border-l-[1.5px] border-dashed border-[#D8D8D8] pl-7 pb-9 relative bg-transparent">
        <div className="pl-2 text-[14px] font-inter-medium pb-5 opacity-40">
          {t('Only adjust the fields you want to import')}
        </div>

        <div className="absolute top-[0] left-[-12px] z-9999 ">
          <Check2Icon className="opacity-40" color={themeColors.primary} />
        </div>
      </div>
      <div className="border-l-[1.5px] border-dashed border-[#D8D8D8] pl-7 pb-9 relative bg-transparent">
        <div className="pl-2 text-[14px] font-inter-medium pb-5 opacity-40">
          {t('Assign the leads to a worker')}
        </div>

        <div className="absolute top-[0] left-[-12px] z-9999 ">
          <Check3Icon className="opacity-40" color={themeColors.primary} />
        </div>
      </div>
      <div className="pl-7 relative bg-transparent">
        <div className="pl-2 text-[14px] font-inter-medium pb-5 opacity-40">
          {t("Remove the leads here that you don't want to import")}
        </div>

        <div className="absolute top-[0] left-[-12px] z-9999 ">
          <Check4Icon className="opacity-40" color={themeColors.primary} />
        </div>
      </div>
      <div className="flex gap-5 justify-end">
        <IconButton
          type="button"
          onClick={() => {
            reset();
            handleFormValuesChange(3, {});
            setresetCount((prevCount) => prevCount + 1);
          }}
          disabled={isLoading}
          secondary={true}
          className={`w-full max-w-[150px] text-[${themeColors.primary}]`}
        >
          {t('Reset')}
        </IconButton>
        <IconButton
          disabled={isLoading}
          icon={<Icon iconType={IconType.UPLOAD_FILE_ICON} />}
          className="w-full max-w-[150px]"
        >
          {isLoading ? t("Processing...") : t("Continue")}
        </IconButton>
      </div>
    </Form>
  );
};

export default Step1;
